module.exports = __webpack_public_path__ + "img/nft-fill.2b56c6f8.svg";